<h2 mat-dialog-title>Patreon linked successfully</h2>
<mat-dialog-content>
    <div style="display: flex; justify-content: center; align-items: center; gap: 50px; margin: 2rem 0 3rem 0">
        <img src="/img/jar.png" alt="Jar" style="width: 100px; height: 100px;">
        <app-icon [icon]="data.patreon_tier.id >= 0 ? 'add' : 'warning'" style="font-size: 50px;"></app-icon>
        
        <picture>
            <source srcset="/img/patreon_icon_dark.svg" media="(prefers-color-scheme: dark)">
            <img src="/img/patreon_icon.svg" alt="Patreon" style="width: 100px; height: 100px;">
        </picture>
    </div>
    
    @if (data.isGuest) {
        <h3 style="margin-top: 0">Guest Submission Successful</h3>
        Your Patreon account <b>{{data.patreon_account_name}}</b> has been linked to your VRChat account <b>{{data.vrchat_name}}</b>.<br>
        You can now claim your in-game perks.
    } @else {
        @if (data.patreon_tier.id >= 0) {
            <p>Your Patreon account <b>{{data.patreon_account_name}}</b> (<span [style.color]="data.patreon_tier.color">{{data.patreon_tier.name}}</span>) has been linked to your account. You can now claim your in-game perks.</p>
        } @else if (data.patreon_tier.id == -1) {
            <p>
                Your Patreon account <b>{{data.patreon_account_name}}</b> has been linked to your account.<br>
            </p>
            <div style="background-color: var(--mat-sys-error-container); padding: 1rem; border-radius: 0.5rem;">
                <h3 style="margin-top: 0">Warning</h3>
                <p>
                    The account you have linked does not have a Patreon subscription.<br>
                    Please verify that you have an active paid subscription and that you have linked the correct account.
                </p>
            </div>
        } @else {
            <p>
                Your Patreon account <b>{{data.patreon_account_name}}</b> has been linked to your account.<br>
            </p>
            <div style="background-color: var(--mat-sys-error-container); padding: 1rem; border-radius: 0.5rem;">
                <h3 style="margin-top: 0">Warning</h3>
                <p>
                    Your last payment was declined. You currently do not have an active paid subscription.<br>
                    Please check your Patreon account for more information.
                </p>
            </div>
        }
    }
    
</mat-dialog-content>
<mat-dialog-actions>
    <button style="width: fit-content;" mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>